export const getBreadcrumbMap = (toc) => {
  const map = {};
  const traverse = (node, path = []) => {
    if (node.title) {
      path.push({
        title: node.title,
        reference: node.reference ?? node.subSection?.[0]?.reference ?? "",
        sectionName: node.sectionName,
      });
    }
    if (node.reference) {
      map[node.reference] = path;
    }
    if (node.subSection) {
      node.subSection.forEach(function (item) {
        traverse(item, path.slice());
      });
    }
  };
  const root = { title: "", reference: "", subSection: toc };
  traverse(root, []);
  delete map[""];
  return map;
};
